module.exports = __webpack_public_path__ + "img/FI23220612.92978cb1.png";